module.exports = __webpack_public_path__ + "img/timeline_en_animated.f35957d2.svg";